import angular from 'angular'
import routers from './routers'
import declareStockRootCtrl from './declareStockRootCtrl'
import { stocks } from 'redevConfig'

const list = (stocks && stocks.list) || ''
const declareStockCtrl = list ? require(`redevelopment/outputManage/stocks/${list.controllerName}`) : require('./declareStockCtrl')
export default angular
    .module('statistics.declareStatistics.declareStock', [
    ]).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }]).controller('declareStockCtrl', declareStockCtrl.default)
    .controller('declareStockRootCtrl', declareStockRootCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/stocks/index.js